import { render } from "./PhoneSelect.vue?vue&type=template&id=9b1633fa"
import script from "./PhoneSelect.vue?vue&type=script&lang=js"
export * from "./PhoneSelect.vue?vue&type=script&lang=js"

import "./PhoneSelect.vue?vue&type=style&index=0&id=9b1633fa&lang=scss"

import exportComponent from "D:\\Projects\\Сurrent_Projects\\inter-qr\\web-updates\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__